import { defineMessages } from 'react-intl';

export default defineMessages({
    caDetailsCollision: {
        id: 'fnol.ca.views.ca-collision-loss-details.Details (Collision)',
        defaultMessage: 'Details (Collision)'
    },
    caWhatHappened: {
        id: 'fnol.ca.views.ca-collision-loss-details.What Happened?',
        defaultMessage: 'What Happened?'
    },
    caDescribeWhatHappened: {
        id: 'fnol.ca.views.ca-collision-loss-details.Describe what happened',
        defaultMessage: 'Describe what happened?'
    },
    caAnyPropertyDamaged: {
        id: 'fnol.ca.views.ca-collision-loss-details.Was any property damaged, other than the vehicle(s) involved in the collision?',
        defaultMessage: 'Was any property damaged, other than the vehicle(s) involved in the collision?'
    },
    caLossDetailsYes: {
        id: 'fnol.ca.views.ca-collision-loss-details.Yes',
        defaultMessage: 'Yes'
    },
    caLossDetailsNo: {
        id: 'fnol.ca.views.ca-collision-loss-details.No',
        defaultMessage: 'No'
    },
    caDescribePropertyDamage: {
        id: 'fnol.ca.views.ca-collision-loss-details.Please describe the property damage',
        defaultMessage: 'Please describe the property damage'
    },
    caWhereDidThisHappenPropertyDamage: {
        id: 'fnol.ca.views.ca-collision-loss-details.Where did this happen?',
        defaultMessage: 'Where did this happen?'
    }
});
